import React, {Fragment} from 'react';
import {Button, Table} from 'react-bootstrap';
import PropTypes from 'prop-types';
import './GroupDetailsTable.css';
import GreenLeafApi from '../utils/GreenLeafApi';
import {toast, ToastContainer} from 'react-toastify';
import ErrorComponent from '../ErrorComponent';

class GroupDetailsTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: null
    };

  }

  async remind(invite) {
    try {
      await GreenLeafApi.GroupTeamAssessment.resendInvite(invite);

      toast.success('Reminder successfully emailed!', {
        position: 'top-center',
        hideProgressBar: true,
        pauseOnHover: false,
        closeButton: false
      });
      this.setState({ errors: null });
    } catch (e) {
      this.setState({ errors: e.errors });
    }
  }

  render() {
    return (
      <Fragment>
        <ErrorComponent error={this.state.errors}/>
        <Table>
          <thead>
          <tr>
            <th>Person</th>
            <th>Status</th>

          </tr>
          </thead>
          <tbody data-cy='detail-body'>
          { this.props.details.map((d, i) => (
            <tr key={i}>
              <td>
                {d.email}
              </td>
              <td>
                {d.complete ? 'Complete' : this.props.closed ? 'Didn\'t Finish' : <Fragment>Pending &nbsp; &nbsp; <Button data-cy='reminder-button' bsSize='xsmall' align='right' onClick={()=> this.remind(d)}>Send Reminder</Button></Fragment>}
              </td>
            </tr>
          ))

          }
          </tbody>
        </Table>

        <ToastContainer
          position="top-center"
          closeOnClick={false}
          autoClose={3000}
          hideProgressBar
          newestOnTop
          rtl={false}
          pauseOnVisibilityChange={false}
          draggablePercent={80}
          pauseOnHover={false}
        />
      </Fragment>
    );
  }
}

GroupDetailsTable.propTypes = {
  details: PropTypes.array.isRequired
};

export default GroupDetailsTable;


// WEBPACK FOOTER //
// ./src/components/teams/GroupDetailsTable.js